import { supabase } from '../lib/supabase'

/**
 * Google event ids that are already one of our shoot days — either an entry
 * somebody made by hand that the worker matched to a shoot, or an event the
 * worker created itself.
 *
 * The calendar uses this to draw each real-world shoot ONCE. Without it,
 * Zeena's "ATM Filming" and Portal OS's ATM shoot day would sit on the same
 * square as two separate things, which is the duplication the whole
 * fill-the-gaps rule exists to prevent — reintroduced visually.
 *
 * Read only on the studio Calendar, never on a client route: these columns
 * are internal plumbing and there is no reason for them to reach a client
 * bundle, whatever RLS would allow.
 */
export async function fetchShootEventIds(): Promise<Set<string>> {
  const ids = new Set<string>()
  if (!supabase) return ids

  const { data, error } = await supabase
    .from('project_shoots')
    .select('calendar_event_id, calendar_manual_event_id')

  if (error) {
    console.warn(`[supabase] shoot calendar links load failed: ${error.message}`)
    return ids
  }

  for (const row of data ?? []) {
    const record = row as Record<string, unknown>
    const own = record.calendar_event_id
    const manual = record.calendar_manual_event_id
    if (own) ids.add(String(own))
    if (manual) ids.add(String(manual))
  }
  return ids
}
